import React from "react";
import TextField from "@mui/material/TextField";

export default function ReadOnlyTextField({
  value,
  label,
  variant = "outlined",
  size = "medium",
  fullWidth = true,
  sx = {},
  ...props
}) {
  const defaultSx = {
    flexGrow: 1,
    ...sx,
  };

  return (
    <TextField
      value={value}
      label={label}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      InputProps={{
        readOnly: true,
      }}
      sx={defaultSx}
      {...props}
    />
  );
}
